import React from 'react';
import PropTypes from 'prop-types';

import VenueMultiSelector from 'components/VenueMultiSelector';
import { manualUserVenuesPropTypes, reduxFormPropTypes, intlMessage } from 'constants/propTypes';
import { InputLabel, InputError } from 'components/Form';

const StaffAccountVenueDropdown = ({
  input: { value, onChange, name },
  venues,
  meta,
  label,
  disabledVenueIds,
  className,
}) => {
  const selectedVenues = value || [];

  return (
    <div className={className}>
      <InputLabel message={label} name={name} />
      <VenueMultiSelector
        onChange={onChange}
        venues={venues}
        selectedVenueIds={selectedVenues}
        isWide
        disabledVenueIds={disabledVenueIds}
      />
      <InputError className="mt-s" {...meta} />
    </div>
  );
};

StaffAccountVenueDropdown.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.number)]),
    onChange: PropTypes.func,
  }),
  disabledVenueIds: PropTypes.arrayOf(PropTypes.number),
  venues: manualUserVenuesPropTypes,
  meta: reduxFormPropTypes.field.meta,
  label: intlMessage,
  className: PropTypes.string,
};

export default StaffAccountVenueDropdown;
